import { csvIcon } from "assets/icons";
import { userProfilePlaceholder } from "assets/images";
import { LoadingButton, TextArea } from "components/form";
import { getFromLocal } from "config/axiosInstance";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import {
  participantSelectedSurveyFeedbackApi,
  toggleParticipantFeedbackStatusApi,
} from "services/survey";
import {
  capitalizeFirstLetter,
  charLimit,
  getValueOrFallback,
  isArrayEmpty,
  isObjectEmpty,
  showImageHandler,
} from "utils/commonHelper";
import SurveyPreview from "../createSurvey/surveyPreview/SurveyPreview";
import { showImageHolder } from "utils/mediaHelper";
import { formattedDateDDMMMYYYY } from "utils/dateHelper";
import { toastMessage } from "utils/toastMessageHelper";
import { removeErrorFields, validateInput } from "validation";
import { survey } from "validation/schema/survey";
import useShimmer from "hooks/useShrimmer";
import SurveyPreviewShimmer from "shrimmer/Survey/SurveyPreviewShimmer";
import { useTranslation } from "react-i18next";

function processSurveyBlocks(blocks) {
  for (const blockKey in blocks) {
    !isArrayEmpty(blocks[blockKey]) &&
      blocks[blockKey].forEach((question, i) => {
        // Extract surveyResponse values
        const surveyResponse = question.surveyResponse?.option || [];
        const value = surveyResponse[0]?.value || "";
        const index = surveyResponse[0]?.index || null;
        const surveyRespOptionValue = surveyResponse[0]?.optionValue || "";

        // Add questionResponse key with surveyResponse value
        question.questionResponse = value;

        // For slider and rating question types, add questionResponseMax
        if (["slider", "rating"].includes(question.questionType)) {
          question.option.forEach((opt) => {
            if (surveyResponse.some((el) => el?.value === opt?.optionValue)) {
              const respInd = surveyResponse.findIndex(
                (el) => el.value === opt.optionValue
              );
              opt.optFeedbackResp = Number(
                surveyResponse[respInd]["optionValue"]
              );
            }
          });

          question.questionResponseMax = value ? Number(value) : 0;
        }

        // Modify options based on surveyResponse index for multiple or image type questions
        if (["image"].includes(question.questionType)) {
          question.option.forEach((opt) => {
            opt.status = opt.rank === index;
          });
        }

        if (["multiple", "single", "image"].includes(question?.questionType)) {
          console.log("I AM QUESTION", question);
          console.log("I AM SURVEY RESP ----->>>>>>>>!!!", surveyResponse);
          question.option.forEach((el) => {
            el.isSelected = surveyResponse.some(
              (resp) => resp?.value === el?.optionValue
            )
              ? true
              : false;
          });
        }

        if (question.questionType === "rankorder") {
          // Create an array to map option ranks to their corresponding index values from surveyResponse
          const orderedIndices = surveyResponse
            .map((response) => response.index)
            .filter((index) => index !== null);

          // Reorder options based on the surveyResponse index order
          question.option.sort(
            (a, b) =>
              orderedIndices.indexOf(a.rank) - orderedIndices.indexOf(b.rank)
          );

          // Set status based on the index in surveyResponse
          question.option.forEach((opt) => {
            opt.status = orderedIndices.indexOf(opt.rank) !== -1;
          });
        }

        // Remove surveyResponse key
        delete question.surveyResponse;
      });
  }
  return blocks;
}

const SelectedParticipantFeedback = ({
  surveyId,
  handleClose,
  selectedSurveyDetail,
  selectedParticipantDetail,
}) => {
  // set all value
  const [participantFeedbackLoader, setParticipantFeedbackLoader] =
    useShimmer(SurveyPreviewShimmer);
  const [feedbackStatusLoader, setFeedbackStatusLoader] = useState(false);
  const [participantFeedbackList, setParticipantFeedbackList] = useState({});
  const [blockArrayList, setBlockArrayList] = useState([]);
  const [blockLength, setBlockLength] = useState({});
  const [feedbackMcqList, setFeedbackMcqList] = useState({});
  const [inputData, setInputData] = useState({ reason: "" });
  const [error, setError] = useState({});

  const [blockTitleArray, setBlockTitleArray] = useState([]);

  const [ratingSliderMcqList, setRatingSliderMcqList] = useState();

  const { t } = useTranslation();

  // function handler

  const closeModelHandler = () => {
    setInputData("");
    handleClose();
  };

  // Input Change handler
  const inputChangeHandler = (event) => {
    const { name, value } = event?.target || {};
    setInputData({ ...inputData, [name]: value });

    setError((prevError) => removeErrorFields(prevError, name));
  };

  // Participant Selected Survey Feedback
  const fetchSelectedParticipantSurveyFeedback = async () => {
    try {
      setParticipantFeedbackLoader(true);
      const reqData = {
        token: getFromLocal(),
        surveyId: surveyId,
        participantId: selectedParticipantDetail?._id,
      };
      const responseData = await participantSelectedSurveyFeedbackApi(reqData);
      const { data, status } = responseData;
      if (status === 200) {
        setRatingSliderMcqList(data?.participantFeedbackSurveyList?.mcqList);
        const { mcqList = {}, ...restparticipantFeedbackSurveyList } =
          data?.participantFeedbackSurveyList || {};
        setParticipantFeedbackList(
          isObjectEmpty(data?.participantFeedbackSurveyList)
            ? {}
            : restparticipantFeedbackSurveyList
        );
        setFeedbackMcqList(
          isObjectEmpty(mcqList) ? {} : processSurveyBlocks(mcqList)
        );
        setBlockTitleArray(data?.titleArray);
        setBlockArrayList(data?.blockArray || []);
        setBlockLength(
          isObjectEmpty(data?.blockLengths) ? {} : data?.blockLengths
        );
      }
    } catch (e) {
      console.log("Error:", e.message);
    } finally {
      setParticipantFeedbackLoader(false);
    }
  };

  // input validation
  const validation = () => {
    const { errors, status } = validateInput(
      inputData,
      "rejectParticipantSelectedFeedbackSchema",
      survey,
      null
    );
    setError(errors);
    return status;
  };

  // Toggle Participant Feedback Status
  const toggleParticipantFeedbackStatus = async (status) => {
    if (status === "accepted" ? true : validation()) {
      try {
        setFeedbackStatusLoader(true);
        const reqData = {
          surveyId: surveyId,
          participantId: selectedParticipantDetail?._id,
          status: status,
          token: getFromLocal() || "",
        };
        if (status === "rejected" && inputData?.reason) {
          reqData.reason = inputData?.reason;
        }
        const responseData = await toggleParticipantFeedbackStatusApi(reqData);
        const { message = "", status: requstStatus } = responseData;
        if (requstStatus === 200) {
          toastMessage(
            message,
            "success",
            "toggleSelectedParticipantFeedbackStatus"
          );
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setFeedbackStatusLoader(false);
        closeModelHandler();
      }
    }
  };

  useEffect(() => {
    fetchSelectedParticipantSurveyFeedback();
  }, []);

  const surveyListStatusHandler = (callType, status) => {
    if (callType === "title") {
      if (status === "accepted") {
        return t(`PARTICIPANT_FEEDBACK.Accepted`);
      }
      if (status === "rejected") {
        return t(`PARTICIPANT_FEEDBACK.Rejected`);
      }

      if (status === "pending") {
        return t(`PARTICIPANT_FEEDBACK.UnderReview`);
      }
    } else {
      return `tag ${status}`;
    }
  };

  //*************************** Handle HTML CODE ************************//
  return (
    <>
      {participantFeedbackLoader || (
        <SurveyPreview
          showAnswer={true}
          surveyMcq={feedbackMcqList}
          titleArray={blockTitleArray}
          surveyBlocks={blockArrayList}
          ratingSliderMcq={ratingSliderMcqList}
        />
      )}

      {/* Right Side Code Area */}
      <div className="survey_feedback">
        <h3>
          {charLimit(getValueOrFallback(selectedSurveyDetail?.title), 16)}
          <span>{`${getValueOrFallback(
            selectedSurveyDetail?.surveyReferenceNumber
          )}`}</span>
        </h3>
        <div className="userId">
          <img
            // src={showImageHolder(
            //   "",
            //   selectedParticipantDetail?.profileUrl,
            //   userProfilePlaceholder
            // )}
            src={userProfilePlaceholder}
            alt=""
          />
          <p>
            <b>{getValueOrFallback(selectedParticipantDetail?.userId)}</b>
            <span className="mx-2">{` ${formattedDateDDMMMYYYY(
              selectedParticipantDetail?.createdAt || ""
            )} . ${
              selectedParticipantDetail?.ageCategory || ""
            } ${getValueOrFallback(
              capitalizeFirstLetter(selectedParticipantDetail?.gender)
            )}`}</span>
          </p>
          <span
            className={surveyListStatusHandler(
              "class",
              participantFeedbackList?.status
            )}
          >
            {surveyListStatusHandler("title", participantFeedbackList?.status)}
          </span>
        </div>
        {participantFeedbackList?.status !== "accepted" && (
          <h3>{t(`PARTICIPANT_FEEDBACK.rejectionReason`)}</h3>
        )}

        {/* {participantFeedbackList?.status === "accepted" && (
          <h4 className="tab_button green">Accepted</h4>
        )}

          {participantFeedbackList?.status === "rejected" && (
            <h4 className="tab_button red">Rejected</h4>
          )}

        {participantFeedbackList?.status === "pending" && (
          <h4 className="tab_button red">Under Review</h4>
        )} */}

        {participantFeedbackList?.status !== "accepted" && (
          <div className="form_field">
            <TextArea
              placeholder={t(`PARTICIPANT_FEEDBACK.enterMessage`)}
              name="reason"
              value={inputData?.reason || participantFeedbackList?.reason}
              onChange={inputChangeHandler}
              error={error?.reason}
              disabled={participantFeedbackList?.status !== "pending"}
            />
            <span className="char_count">
              {participantFeedbackList?.reason?.length ?? 0}/500
            </span>
            {participantFeedbackList?.status === "pending" && (
              <p>{t(`PARTICIPANT_FEEDBACK.reasonNotes`)}</p>
            )}

            {/* <Button type={"button"} className={"w-100 green"}>
            <img src={csvIcon} alt="" /> Export to CSV/XlSX
          </Button> */}
          </div>
        )}
        {participantFeedbackList?.status === "pending" && (
          <div className="button_wrap">
            <LoadingButton
              type={"button"}
              className={"red light"}
              onClick={() => toggleParticipantFeedbackStatus("rejected")}
              loading={feedbackStatusLoader}
            >
              {t(`PARTICIPANT_FEEDBACK.reject`)}
            </LoadingButton>
            <LoadingButton
              type={"button"}
              onClick={() => toggleParticipantFeedbackStatus("accepted")}
              loading={feedbackStatusLoader}
            >
              {t(`PARTICIPANT_FEEDBACK.accept`)}
            </LoadingButton>
          </div>
        )}
      </div>
    </>
  );
};

export default SelectedParticipantFeedback;
